module.exports = __webpack_public_path__ + "202408221624/img/nu.b170503f.png";